// comparison-slider.js - BESVOL 对比滑块交互逻辑 v2.2
// 更新: 终止位置设置为最右边 (100%)

class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.mediaWrapper = this.querySelector("[data-comparison-slider]");
    this.slider = this.querySelector(".cs-slider");
    
    if (!this.mediaWrapper || !this.slider) {
      console.error("ComparisonSlider: Required elements not found");
      return;
    }
    
    this.orientation = this.mediaWrapper.dataset.orientation || "horizontal";
    this.isDragging = false;
    
    this.init();
  }
  
  init() {
    this.slider.addEventListener("input", this.handleInput.bind(this));
    this.slider.addEventListener("pointerdown", this.handlePointerDown.bind(this));
    document.addEventListener("pointerup", this.handlePointerUp.bind(this));
    
    this.mediaWrapper.addEventListener("touchstart", this.handleTouchStart.bind(this), { passive: false });
    this.mediaWrapper.addEventListener("touchmove", this.handleTouchMove.bind(this), { passive: false });
    this.mediaWrapper.addEventListener("touchend", this.handleTouchEnd.bind(this));
    
    this.mediaWrapper.addEventListener("mousedown", this.handleMouseDown.bind(this));
    document.addEventListener("mousemove", this.handleMouseMove.bind(this));
    document.addEventListener("mouseup", this.handleMouseUp.bind(this));
    
    this.updateCompare(100);
    this.slider.value = 100;
  }
  
  handleInput(e) {
    const value = parseInt(e.target.value);
    this.updateCompare(value);
  }
  
  handlePointerDown() {
    this.isDragging = true;
    this.mediaWrapper.style.setProperty("--transition-duration", "0s");
  }
  
  handlePointerUp() {
    if (this.isDragging) {
      this.isDragging = false;
      this.mediaWrapper.style.setProperty("--transition-duration", "0.3s");
    }
  }
  
  handleTouchStart(e) {
    this.isDragging = true;
    this.mediaWrapper.style.setProperty("--transition-duration", "0s");
    this.updateFromTouch(e.touches[0]);
  }
  
  handleTouchMove(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    this.updateFromTouch(e.touches[0]);
  }
  
  handleTouchEnd() {
    this.isDragging = false;
    this.mediaWrapper.style.setProperty("--transition-duration", "0.3s");
  }
  
  handleMouseDown(e) {
    this.isDragging = true;
    this.mediaWrapper.style.setProperty("--transition-duration", "0s");
    this.updateFromMouse(e);
  }
  
  handleMouseMove(e) {
    if (!this.isDragging) return;
    this.updateFromMouse(e);
  }
  
  handleMouseUp() {
    this.isDragging = false;
    this.mediaWrapper.style.setProperty("--transition-duration", "0.3s");
  }
  
  updateFromTouch(touch) {
    const rect = this.mediaWrapper.getBoundingClientRect();
    let percentage;
    if (this.orientation === "horizontal") {
      percentage = ((touch.clientX - rect.left) / rect.width) * 100;
    } else {
      percentage = ((touch.clientY - rect.top) / rect.height) * 100;
    }
    percentage = Math.max(0, Math.min(100, percentage));
    this.updateCompare(percentage);
    this.slider.value = percentage;
  }
  
  updateFromMouse(e) {
    const rect = this.mediaWrapper.getBoundingClientRect();
    let percentage;
    if (this.orientation === "horizontal") {
      percentage = ((e.clientX - rect.left) / rect.width) * 100;
    } else {
      percentage = ((e.clientY - rect.top) / rect.height) * 100;
    }
    percentage = Math.max(0, Math.min(100, percentage));
    this.updateCompare(percentage);
    this.slider.value = percentage;
  }
  
  updateCompare(value) {
    this.mediaWrapper.style.setProperty("--compare", value);
  }
}

if (!customElements.get("comparison-slider-component")) {
  customElements.define("comparison-slider-component", ComparisonSlider);
}

document.addEventListener("DOMContentLoaded", function() {
  const sliders = document.querySelectorAll("comparison-slider-component");
  sliders.forEach(slider => {
    if (slider.slider) {
      slider.updateCompare(100);
      slider.slider.value = 100;
    }
  });
});

document.addEventListener("shopify:section:load", function(event) {
  const slider = event.target.querySelector("comparison-slider-component");
  if (slider && slider.slider) {
    slider.updateCompare(100);
    slider.slider.value = 100;
  }
});
